module.exports = __webpack_public_path__ + "static/media/automate.ac8055e6.svg";